"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useDeepEqualMemo", {
    get: ()=>useDeepEqualMemo,
    enumerable: true
});
const _interopRequireDefault = require("@swc/helpers/lib/_interop_require_default.js").default;
const _react = require("react");
const _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
function useDeepEqualMemo(value) {
    const memoizedValue = (0, _react.useRef)(value);
    // only update the value if it's not deep equal
    if (!(0, _reactFastCompare.default)(value, memoizedValue.current)) {
        memoizedValue.current = value;
    }
    return memoizedValue.current;
}
